import { Stripe, PaymentMethod } from '@stripe/stripe-js';
import { StripePaymentData } from '../../types/stripe/payment-data';

export const handlePaymentData = async (
  stripe: Stripe,
  paymentData: StripePaymentData
): Promise<PaymentMethod | undefined> => {
  const { error, paymentMethod } = await stripe.createPaymentMethod({
    type: 'card',
    card: paymentData.cardElement,
    billing_details: {
      name: paymentData.fullName,
      address: {
        postal_code: paymentData.zipCode,
      },
    },
    metadata: {
      customer: '',
    },
  });

  if (error) {
    throw error;
  }

  return paymentMethod;
};
